import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../constants/preferences/home_match_preferences_wizard_content";
import {HomeMatchPreferencesWizardStep} from "./get_home_match_preferences_wizard_steps";

const {NEXT, PHONE_SUBMIT, SAVE, SAVE_AND_EXIT, SMS, SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IParams {
    isParameterEntry: boolean;
    returnsToSummary?: boolean;
    step: HomeMatchPreferencesWizardStep;
}

export const getHomeMatchPreferencesWizardPrimaryLabel = (params: IParams) => {
    const {isParameterEntry, returnsToSummary = false, step} = params;

    switch (step) {
        case HomeMatchPreferencesWizardStep.SMS:
            return SMS.CONFIRM;
        case HomeMatchPreferencesWizardStep.SUMMARY:
            return SUMMARY.CONFIRM;
        case HomeMatchPreferencesWizardStep.PHONE:
            return PHONE_SUBMIT;
        default:
            if (isParameterEntry && !returnsToSummary) return SAVE_AND_EXIT;

            return isParameterEntry ? SAVE : NEXT;
    }
};
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../constants/preferences/home_match_preferences_wizard_content";
import {HomeMatchPreferencesWizardStep} from "./get_home_match_preferences_wizard_steps";

const {NEXT, PHONE_SUBMIT, SAVE, SAVE_AND_EXIT, SMS, SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IParams {
    isParameterEntry: boolean;
    returnsToSummary?: boolean;
    step: HomeMatchPreferencesWizardStep;
}

export const getHomeMatchPreferencesWizardPrimaryLabel = (params: IParams) => {
    const {isParameterEntry, returnsToSummary = false, step} = params;

    switch (step) {
        case HomeMatchPreferencesWizardStep.SMS:
            return SMS.CONFIRM;
        case HomeMatchPreferencesWizardStep.SUMMARY:
            return SUMMARY.CONFIRM;
        case HomeMatchPreferencesWizardStep.PHONE:
            return PHONE_SUBMIT;
        default:
            if (isParameterEntry && !returnsToSummary) return SAVE_AND_EXIT;

            return isParameterEntry ? SAVE : NEXT;
    }
};
